// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import element from 'element-ui'
import { sync } from 'vuex-router-sync'
import App from './App'
import i18n from 'libraries/i18n'
import store from 'libraries/store'
import router from 'libraries/router'
import plugins from 'libraries/plugins'

// ## Import styles
// =========================
import 'element-ui/lib/theme-default/index.css'
import 'assets/styles/main.scss'

// 本地测试使用
// Vue.prototype.$GlobalDataURL = 'http://1.117.158.212:10015/v1'
// Vue.prototype.$GlobalRemoteUrl = 'http://1.117.158.212:8081'
// // Vue.prototype.$GlobalRemoteUrl = 'http://localhost:8081'
// Vue.prototype.$GlobalIoTUrl = 'http://iot.labsop.cn:12001'

// 发布使用
Vue.prototype.$GlobalDataURL = '/dataURL/'
Vue.prototype.$GlobalRemoteUrl = '/remoteURL/'
Vue.prototype.$GlobalIoTUrl = '/IoTURL/'

// 添加全局配置参数
Vue.prototype.$GlobalConfig = {
  security: {
    enableScreenLock: false,      // 是否启用屏幕锁定
    enablePasswordExpiry: false,  // 是否启用密码过期检查
    enableComplexPassword: false, // 是否启用复杂密码规则
    screenLockTimeout: 30 * 60 * 1000,  // 屏幕锁定超时时间（默认30分钟）
    passwordExpiryDays: 30       // 密码过期天数（默认30天）
  }
}

// ## Use plugins
// =========================
Vue.use(element)
Vue.use(plugins)
sync(store, router, { moduleName: 'route' })

// ## Config
// =========================
Vue.config.debug = process.env.NODE_ENV === 'development'
Vue.config.silent = !Vue.config.debug
Vue.config.devtools = true
Vue.config.productionTip = false

// ## Initial
// =========================
// Element默认不支持 6.x 的 vue-i18n，需要手动处理。
Vue.use(element, {
  i18n: key => i18n.vm._t(key)
})

// ## Root app
// =========================
const app = new Vue({
  name: 'root',
  i18n: i18n,
  store: store,
  router: router,
  render: h => h(App)
})

// ## Mount to `#app` element
// =========================
app.$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js